import { useContext, useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Alert, Box, Stack } from '@mui/material';
// components
import Logo from '../../components/logo';
import Loading from '../../components/loading';
import AccountPopover from '../dashboard/header/AccountPopover';
import { EntityContext } from '../../entity';
import { AccountContext } from '../../account';

// ----------------------------------------------------------------------

const StyledHeader = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
}));

// ----------------------------------------------------------------------

export default function SimpleLayout() {
  const { loading, erro, setErro, errorMessage } = useContext(EntityContext);
  const { getSession } = useContext(AccountContext);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const getSessionRef = useRef(getSession);

  // Atualizar ref quando getSession mudar
  useEffect(() => {
    getSessionRef.current = getSession;
  }, [getSession]);

  useEffect(() => {
    getSessionRef.current()
      .then(() => {
        setIsAuthenticated(true);
      })
      .catch(() => {
        setIsAuthenticated(false);
      });
  }, []); // Executar apenas uma vez na montagem

  return (
    <>
      <StyledHeader>
        <Box sx={{ flex: 1 }}>
          {erro ? (
            <Alert severity="warning" onClose={() => setErro(false)}>
              {errorMessage}
            </Alert>
          ) : (
            <Logo />
          )}
        </Box>
        {isAuthenticated && (
          <Stack
            direction="row"
            alignItems="center"
            spacing={{
              xs: 0.5,
              sm: 1,
            }}
            sx={{ ml: 'auto' }}
          >
            <AccountPopover />
          </Stack>
        )}
      </StyledHeader>
      {loading && <Loading />}

      {/* Espaço para o header absoluto (logo + conta); evita título encavalado no mobile */}
      <Box
        component="main"
        sx={{
          width: '100%',
          pt: { xs: 12, sm: 11, md: 10 },
          boxSizing: 'border-box',
        }}
      >
        <Outlet />
      </Box>
    </>
  );
}
